import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { FormSessionCanDeactivate, PatientService, UserService } from '../../shared';
import { environment } from '../../shared/config/app-config';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { Options } from '@angular-slider/ngx-slider';
@Component({
  selector: 'app-editsymptom',
  templateUrl: './editsymptom.component.html',
  styleUrls: ['./editsymptom.component.css']
})
export class EditsymptomComponent extends FormSessionCanDeactivate {
  surveydownloadurl: any = environment.surveydownloadUrl;
  public timealert = environment.timelimit;
  bsConfig: { containerClass: string; showWeekNumbers: boolean; dateInputFormat: string; };
  dateformat: string;
  public previousUrl: any = [];
  public params: any;
  public user: any = {};
  public surveydate: any = {};
  public survey = [];
  enablepage = false;
  apiurl: any = environment.api_url
  todoOverallCompleted: any;
  todoCpAssigned: any;
  public currentUser: any;
  constructor(private router: Router, private routeParams: ActivatedRoute, private DatePipe: DatePipe,
    private patientService: PatientService, private userService: UserService, private toast: ToastrService) {

    super();
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;


    this.routeParams.params.subscribe(params => {
      this.params = params;

    });
  }

  ngOnInit() {
    let self = this;
    self.getCurrentUser()
    self.getUserDetails()
    self.getSurveyDetails()
    self.getSurveyDete()

    this.todoOverallCompleted = this.params.todoOverallCompleted.replace(/-/g, "/");
    this.todoCpAssigned = this.params.todoCpAssigned.replace(/-/g, "/");
  }
  imageURL: string = environment.cloudeImageURL;
  getCurrentUser() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
        if (this.currentUser.item) {
          if (this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.currentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        }
      }
    )


  }
  getSurveyDete() {
    let self = this;

    self.patientService.getSurveyassigndate(self.params.surveyId, self.params.patSwfId)
      .subscribe(data => {
        // ////console.log(data)
        self.surveydate = data;
      })
  }
  getUserDetails() {
    let self = this;
    self.patientService.getSuveryUserDetais(self.params.patId, self.params.patSwfId)
      .subscribe(data => {
        if (Array.isArray(data) && data.length)
          self.user = data[0]
      })
  }

  getSurveyDetails() {
    let self = this;
    self.patientService.getSurveyDetailsbySurevy(self.params.surveyId, self.params.patSwfId, '0')
      .subscribe(data => {
        if(data && data[1]?.result && data[1]?.result.length > 0)
          for (var g = 0; g < data[1].result.length; g++) {
            if (data[1].result[g].resultAnswerValue == 'null' && data[0].survey.sQuestion[g].questiontype.toLowerCase().includes('slider')) {
              data[1].result[g].resultAnswerValue = "0"
            }
          }
        self.survey = data;
        self.enablepage = true;
      })
  }

  submitForm(emp) {
    let self = this;
    self.router.navigateByUrl(`/survey/${this.params.surveyId}/${this.params.surveyName}/${this.params.patSwfId}/${this.params.careplansurveyid}`)
  }

  loginAsPAtient(credentials, workflowid) {
    this.userService
      .attemptsurveyAuth(credentials, this.params.patSwfId, this.params.surveyId, this.params.surveyName, workflowid)
      .subscribe(
        data => data,
        err => {

        }
      );
  }
  checkans(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checkold(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == "OLD")
    })
    let index1 = 0;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && (result[i].selectAnswerType == null || result[i].selectAnswerType == undefined)) {
        index1 = -1;
        break;
      }
    }

    if (index != -1 && index1 != -1) {
      return true
    } else {
      return false;
    }
  }
  checknew(result: any[], ansid) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.choicetypeFk == ansid && o.selectAnswerType == null)
    })
    let index1 = -1;
    let oldnew = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].choicetypeFk == ansid && result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
      if (result[i].selectAnswerType == "OLD") {
        oldnew = i
      }
    }

    if (index != -1 && index1 == -1 && oldnew != -1) {
      return true
    } else {
      return false;
    }
  }
  checknewtext(result: any[]) {
    let index = _.findIndex(result, (o: any): any => {
      return (o.selectAnswerType == null)
    })
    let index1 = -1;
    for (var i = 0; i < result.length; i++) {
      if (result[i].selectAnswerType == "OLD") {
        index1 = i;
        break;
      }
    }
    if (index != -1 && index1 != -1) {
      if (result[index].choiceValue != result[index1].choiceValue) {
        return true
      }
    } else {
      return false;
    }
  }

  checksold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }
      }
    }

    if (index1 == -1 && index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknold(result: any[], ansid) {
    let index1
    var answer = result[0].choiceValue.split('##');
    index1 = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    let index = -1;
    let old = -1
    for (var i = 0; i < result.length; i++) {
      answer = result[i].choiceValue.split('##');
      for (var j = 0; j < answer.length; j++) {
        if (answer[j] == ansid && result[i].selectAnswerType == 'OLD') {
          index = j
        }

      }
      if (result[i].selectAnswerType == 'OLD') {
        old = i
      }
    }

    if (index1 != -1 && index == -1 && old != -1) {
      return true
    } else {
      return false;
    }


  }
  checksans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');
    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })
    if (index != -1) {
      return true
    } else {
      return false;
    }
  }
  checknans(result: any[], ansid) {
    let index
    var answer = result[0].choiceValue.split('##');

    index = _.findIndex(answer, (o: any): any => {
      return o == ansid
    })

    if (index == -1) {
      if (result[0].choiceValue == '') {
        return false
      }
      else
        return true;
    } else {
      return false;
    }
  }
  editsurvey() {
    let surveyData = {
      'name': this.params.surveyId,
      'title': this.params.surveyName,
      'swfid': this.params.patSwfId,
      'patstatus': this.params.patstatus,
      'patid': this.params.patId,
      'surveyname': this.params.survey,
      'todocategoryid': this.params.todocategoryid,
      'careplansurveyid': this.params.careplansurveyid,
      'patedit': 'edit',
      'type': 1,
      'patact': this.params.patact
    }
    window.localStorage['surveyData'] = btoa(JSON.stringify(surveyData))
    this.router.navigate([`/care/survey`])
  }
  updateccreviewed() {
    let self = this
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    self.patientService.updateccviewd(self.params.patSwfId, self.params.surveyId, self.params.survey, self.params.todocategoryid, self.params.careplansurveyid, startdate, enddate)
      .subscribe(data => {
        ////console.log(data)
        if (data[0].status == 'Success') {
          this.toast.success(this.userService.translateText('hospital_portal.patient_dtls.survey_viewed.success'), '', {
            timeOut: this.timealert
          })
          this.userService.logAudit('updateDashboardCarePlanTodoAfterCcViewed', 0).subscribe(data => { })
          this.router.navigateByUrl(`/care/patientsummary`)
        } else {
          this.toast.error(this.userService.translateText('patient_portal.display_messages.something_went_wrong'), '', {
            timeOut: this.timealert
          })
        }
      })
  }
  onPrint() {
    let printContents;
    let data: any = {
      preview: true,
      hspPatSurveyId: this.params.surveyId,
      patientSwfId: this.params.patSwfId,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    printContents = this.surveydownloadurl + data
    // printContents = document.getElementById('print-section').innerHTML;
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  getnullvalue(value) {
    if (value) {
      if (value.toLowerCase() == 'null') {
        return ''
      } else {
        return value
      }
    } else {
      return ''
    }
  }

  sliderOption(anstype) {
    let options: Options = {
      floor: 0,
      ceil: anstype.max,
      step: 1,
      minRange: anstype.min,
      maxRange: anstype.max,
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

}
